import { render, staticRenderFns } from "./RelativeRelationForm.vue?vue&type=template&id=3bebbc70&scoped=true&"
import script from "./RelativeRelationForm.vue?vue&type=script&lang=js&"
export * from "./RelativeRelationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bebbc70",
  null
  
)

export default component.exports